import { configureStore } from "@reduxjs/toolkit";
import headerlabel from "./slices/headerLabel";

export const store = configureStore({
  reducer: {
    label: headerlabel,
  },
});
